export const pinExtraAction = {
  color: 'subdued',
  iconType: 'pin',
  iconSize: 's',
  'aria-label': 'Pin to top',
};
